import { Component, OnInit, ViewChild } from '@angular/core';
import { CrudService } from '../../../crud/crud.service';

import { Mensaje } from '../../../mensaje';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-articulo-lista',
  templateUrl: './lista.component.html'
})

export class SucursalComponent {
  @ViewChild('ctrl') ctrl;
  tamano = document.body.clientHeight;
  permisos = JSON.parse(localStorage.getItem("permisos"));
  busquedaActivada = false;
  color = [];
  etiquetas = [];
  todos = false;
  articulo: any = {
    tipos_movimientos_id: 5,
    comentarios: '',
    nombre: '',
    id: '',
    status_movimientos_id: 1,
    categorias: {},
    presentaciones: {},
    unidades_medidas: {},
    stoks: []
  };

  respuesta: any[] = [];
  mensajeResponse: Mensaje = new Mensaje(true);


  abrirModal(id, item, tipo, i) {
    this.articulo = item;
    this.articulo['tipos_movimientos_id'] = tipo;
    this.articulo['index'] = i;
    document.getElementById(id).classList.add('is-active');
  }

  constructor(private crudService: CrudService, private notificacion: NotificationsService) { }

  cancelarModal(id) {
    document.getElementById(id).classList.remove('is-active');
  }
  ajustar(i) {
    let id = "ajuste_inventario";
    let tipo = this.articulo["tipos_movimientos_id"] == 5 ? 'mas' : 'menos';
    this.crudService.crear(this.articulo, "ajuste-" + tipo).subscribe(
      resultado => {
        this.mensajeResponse.texto = resultado.messages;
        this.mensajeResponse.mostrar = true;
        if (resultado.status == 201)
          this.mensajeResponse.clase = 'success';
        else
          this.mensajeResponse.clase = 'warning';
        this.mensaje(3);
        this.color[i] = true;
        this.ctrl.dato[i] = resultado.data;
        this.cancelarModal(id);
        setTimeout(() => {
          this.color[i] = false;
        }, 3500);
      },
      error => {
        this.mensajeResponse.texto = "No especificado.";
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = 'error';
        this.mensaje(3);
        this.cancelarModal(id);
      }
    );
  }

  public options = {
    position: ["bottom", "left"],
    timeOut: 2000,
    lastOnBottom: true
  };

  titulo = 'Ajuste';
  mensaje(cuentaAtras: number = 6, posicion: any[] = ["bottom", "left"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };
    if (this.mensajeResponse.titulo == '')
      this.mensajeResponse.titulo = this.titulo;

    if (this.mensajeResponse.clase == 'alert')
      this.notificacion.alert(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'success')
      this.notificacion.success(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'info')
      this.notificacion.info(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'warning' || this.mensajeResponse.clase == 'warn')
      this.notificacion.warn(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'error' || this.mensajeResponse.clase == 'danger')
      this.notificacion.error(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

  }

  todas_etiqueta( data) {
    this.etiquetas = [];
    this.todos = !this.todos;
    if(this.todos){
      data.forEach(element => {
        this.etiquetas.push(element);
      });
    }
  }

  etiqueta(item) {
    let i = this.etiquetas.indexOf(item);
    if(i > -1){
      this.etiquetas.splice(i, 1);
    } else{
      this.etiquetas.push(item);
    }
  }

  imprimir_etiqueta() {
    let html = document.getElementById('etiquetas_imp').innerHTML;
    html = '<html lang="es">'
      + ' <head>'
      + ' <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />'
      + ' <meta name="charset" content="UTF-8">'
      + ' <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">'
      + ' <meta name="apple-mobile-web-app-capable" content="yes">'
      + ' <title>PDF</title> <meta name="viewport" content="initial-scale=1" />'
      + ' </head>'
      + ' <body>'
      + html
      + ' </body>'
      + ' </html>';
    let iframe = document.createElement('iframe');
    iframe.setAttribute('id', 'printf');

    document.body.appendChild(iframe);

    const mywindow: HTMLIFrameElement = document.getElementById('printf') as HTMLIFrameElement;
      mywindow.contentWindow.document.write(html);
      setTimeout(() => {
        //  lanzar la sentencia imprimir
        mywindow.contentWindow.print();
      }, 500);
      setTimeout(() => {
        //  remover el contenedor de impresión
        document.body.removeChild(iframe);
      }, 2000);
  }
}
